(function () {
  // Shopify's /contact endpoint requires a CAPTCHA token that its own inline
  // script attaches during a native form submit. Intercepting submit with
  // fetch() skips that listener and the request is rejected with
  // "400 Missing CAPTCHA token". So we let the browser submit natively
  // (CAPTCHA + Shopify's own redirect handle it), and instead detect the
  // `contact_posted=true` query param Shopify appends on redirect back to
  // this page to drive the success / auto-reset UI.

  function initQuoteForm(form) {
    if (form.dataset.quoteFormInit) return;
    form.dataset.quoteFormInit = 'true';

    var body = form.querySelector('[data-quote-form-body]');
    var success = form.querySelector('[data-quote-form-success]');
    var submitBtn = form.querySelector('.slideshow__quote-form-submit');
    var submitLabel = form.querySelector('.slideshow__quote-form-submit-label');
    var submitSpinner = form.querySelector('.slideshow__quote-form-submit-spinner');
    var durationEl = form.querySelector('[data-success-duration-value]');
    var duration = (parseFloat(durationEl && durationEl.textContent) || 8) * 1000;
    // Panels are rendered in page order (1-10, skipping unused pages), one
    // per merchant-configured "Wizard page" value on each form field block.
    var panels = Array.prototype.slice.call(form.querySelectorAll('[data-quote-panel]'));

    function refreshSlideHeight() {
      // The section lives inside a Swiper carousel (overflow:hidden). Swiper's
      // own autoHeight option is off site-wide (see slideshow.js) so every
      // slide shares one fixed height - swiper.updateAutoHeight() is a no-op
      // in that mode and never actually resizes anything. Toggling wizard
      // panels / success state can need more room than that shared height
      // allows though, so grow (never shrink) the wrapper by hand to fit
      // whichever is taller, instead of letting the extra content clip.
      // Never shrinking keeps other slides' shared height untouched.
      var swiperEl = form.closest('.swiper');
      var wrapperEl = swiperEl && swiperEl.querySelector('.swiper-wrapper');
      var activeSlide = swiperEl && swiperEl.querySelector('.swiper-slide-active');
      if (!wrapperEl || !activeSlide) return;

      function apply() {
        var neededHeight = activeSlide.scrollHeight;
        var currentHeight = wrapperEl.getBoundingClientRect().height;
        if (neededHeight > currentHeight) {
          wrapperEl.style.height = neededHeight + 'px';
        }
      }
      apply();
      window.setTimeout(apply, 420);
    }

    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.disabled = isLoading;
      submitBtn.classList.toggle('is-loading', isLoading);
      if (submitSpinner) submitSpinner.hidden = !isLoading;
      if (submitLabel) submitLabel.style.visibility = isLoading ? 'hidden' : '';
    }

    function activatePanel(index, shouldFocus) {
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === index);
      });
      if (shouldFocus) {
        var activePanel = panels[index];
        var firstField = activePanel && activePanel.querySelector('input, textarea');
        if (firstField) firstField.focus();
      }
      refreshSlideHeight();
    }

    function goToPanel(targetIndex) {
      if (targetIndex < 0 || targetIndex >= panels.length) return;
      activatePanel(targetIndex, true);
    }

    // Checkboxes are individually optional, but fields sharing a
    // data-checkbox-group (see "Group with checkbox above") can require at
    // least one checked within that group. Native `required` can't express
    // "at least one of these", so this uses setCustomValidity() on the first
    // member of each group instead, kept live via a 'change' listener below.
    function validateCheckboxGroups() {
      var groups = {};
      form.querySelectorAll('[data-checkbox-group]').forEach(function (cb) {
        var key = cb.getAttribute('data-checkbox-group');
        (groups[key] = groups[key] || []).push(cb);
      });
      Object.keys(groups).forEach(function (key) {
        var members = groups[key];
        var isRequired = members.some(function (m) {
          return m.getAttribute('data-checkbox-required') === 'true';
        });
        var isChecked = members.some(function (m) {
          return m.checked;
        });
        members[0].setCustomValidity(isRequired && !isChecked ? 'Please select at least one option.' : '');
      });
    }

    function validatePanel(panel) {
      validateCheckboxGroups();
      var fields = panel.querySelectorAll('[required], [data-checkbox-group]');
      var firstInvalid = null;
      // Reuse the site-wide custom inline-error-message system (see
      // form-validation.js) instead of the native reportValidity() bubble,
      // so this wizard's "Continue" gating looks the same as every other
      // form's validation instead of a jarring native browser tooltip.
      var validateField = window.themeFormValidation && window.themeFormValidation.validateField;
      fields.forEach(function (field) {
        var isValid = validateField ? validateField(field) : field.checkValidity();
        if (!isValid && !firstInvalid) firstInvalid = field;
      });
      if (firstInvalid) {
        firstInvalid.focus();
        return false;
      }
      return true;
    }

    function showSuccess() {
      if (body) body.hidden = true;
      if (success) {
        success.hidden = false;
        // restart the CSS animation
        success.classList.remove('is-visible');
        // eslint-disable-next-line no-unused-expressions
        void success.offsetWidth;
        success.classList.add('is-visible');
      }
      refreshSlideHeight();
      window.setTimeout(function () {
        form.reset();
        if (panels.length > 1) activatePanel(0);
        if (success) {
          success.hidden = true;
          success.classList.remove('is-visible');
        }
        if (body) body.hidden = false;
        refreshSlideHeight();
      }, duration);
    }

    // Chip checkboxes/radios: toggle explicitly on click of the label instead
    // of relying on the browser's native label-click-forwarding, which proved
    // unreliable on some real devices (occasionally needing 2-3 clicks).
    form.querySelectorAll('.quote-chip').forEach(function (chip) {
      var chipInput = chip.querySelector('.quote-chip__input');
      if (!chipInput) return;
      chip.addEventListener('click', function (event) {
        // A keyboard Space/Enter on the (invisible, pointer-events:none)
        // input fires its own native click, which still bubbles here. Let
        // that native toggle stand as-is instead of double-toggling it.
        if (event.target === chipInput) return;
        event.preventDefault();
        if (chipInput.disabled) return;
        if (chipInput.type === 'radio') {
          if (chipInput.checked) return;
          chipInput.checked = true;
        } else {
          chipInput.checked = !chipInput.checked;
        }
        chipInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    if (panels.length > 1) {
      form.classList.add('is-wizard');
      activatePanel(0);

      panels.forEach(function (panel, index) {
        var continueBtn = panel.querySelector('[data-quote-continue]');
        var backBtn = panel.querySelector('[data-quote-back]');
        if (continueBtn) {
          continueBtn.addEventListener('click', function () {
            if (!validatePanel(panel)) return;
            goToPanel(index + 1);
          });
        }
        if (backBtn) {
          backBtn.addEventListener('click', function () {
            goToPanel(index - 1);
          });
        }
      });
    }

    // Keep custom validity live as the user checks/unchecks boxes, so the
    // browser's own native pre-submit check (which runs before the 'submit'
    // event even fires) already reflects the current checkbox-group state.
    form.addEventListener('change', function (event) {
      if (event.target.hasAttribute('data-checkbox-group')) validateCheckboxGroups();
    });
    validateCheckboxGroups();

    // form-validation.js's own document-level submit listener (capture
    // phase, runs before this one) already blocks and shows inline errors
    // for an invalid submission - if this handler runs at all, the form
    // already passed that check.
    form.addEventListener('submit', function () {
      setLoading(true);
    });

    if (/[?&]contact_posted=true/.test(window.location.search)) {
      var cleanUrl = window.location.pathname + window.location.hash;
      window.history.replaceState(null, '', cleanUrl);
      showSuccess();
    }
  }

  function init() {
    document.querySelectorAll('form.js-quote-form').forEach(initQuoteForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
